import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../appStore";
import { EAppReducers } from "../../white-list";

const getState = (state: RootState) => state[EAppReducers.EXERCISE];

export const exerciseSelector = createSelector(getState, (state) => state);
